import { render, staticRenderFns } from "./AppDropzone.vue?vue&type=template&id=09b9317d&scoped=true&"
import script from "./AppDropzone.vue?vue&type=script&lang=js&"
export * from "./AppDropzone.vue?vue&type=script&lang=js&"
import style0 from "./AppDropzone.vue?vue&type=style&index=0&id=09b9317d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b9317d",
  null
  
)

export default component.exports